import React from 'react';

const box = {
  border: '1px solid var(--line-strong)',
  borderRadius: 6,
  padding: '6px 10px',
  fontSize: 12,
  fontWeight: 700,
};

function PageShellDemoComponent() {
  return (
    <div style={{ display: 'grid', gap: 6, maxWidth: 560 }}>
      <div style={{ ...box, background: 'var(--navy)', color: '#fff' }}>
        .pageheader — fixed 80px band rendered by the shell (content.js) for every route
      </div>
      <div style={{ ...box, background: 'var(--surface-2)' }}>
        .contentwrapper — your page root, offset top: 80px
        <div style={{ ...box, marginTop: 6, background: 'var(--surface)' }}>
          fixed-shell page: height calc(100vh - 80px), flex column
          <div style={{ ...box, marginTop: 6, borderStyle: 'dashed' }}>
            inner region: overflow-y auto — ONLY this scrolls
          </div>
        </div>
      </div>
    </div>
  );
}

export const pageShellDemo = {
  id: 'page-shell',
  title: 'Migrated-page shell pattern',
  category: 'Navigation & Layout',
  importPath: 'src/Css/design-system/bravo-app.css (.contentwrapper / .blist-page pattern)',
  notes: [
    'The shell (content.js) renders the 80px .pageheader band for every route — migrated pages must wrap their root in .contentwrapper (top: 80px) or content overlaps the header.',
    'Fixed-header page (header stays, content scrolls): root height calc(100vh - 80px) + flex column, inner region overflow-y: auto. Reference: .blist-page (Messages/Downloads) and this gallery’s own .dsg-page.',
    'The header eyebrow text comes from the active top-level menu group; in-app navigation must pass the group OBJECT on link_click.',
  ],
  snippet:
    "<div className='bravo-ds my-page contentwrapper'>\n  {/* .my-page: height calc(100vh - 80px); display flex; flex-direction column */}\n  <div className='my-page-toolbar'>...fixed toolbar...</div>\n  <div className='my-page-scroll'>...only this region scrolls...</div>\n</div>",
  render: PageShellDemoComponent,
};
